module.exports = __webpack_public_path__ + "static/media/success.f474d30f.svg";